// Copyright (c) 2024 Deere & Company

import t from 'tcomb';

const ResponsibleDealerReport = t.struct({
    activeWarranty: t.maybe(t.String),
    customerName: t.maybe(t.String),
	deliveryDate: t.maybe(t.Number),
    description: t.maybe(t.String),
    entityID: t.maybe(t.String),
	model: t.maybe(t.String),
    modelYear: t.maybe(t.String),
	openPips: t.maybe(t.String),
	pin: t.maybe(t.String),
	responsibleDealer: t.maybe(t.String)

}, 'ResponsibleDealerReport');

export const getDefaultState = () => new ResponsibleDealerReport({
	activeWarranty: '',
	customerName: '',
	deliveryDate: null,
	description: '',
	entityID: '',
	model: '',
	modelYear: '',
	openPips: '',
	pin: '',
	responsibleDealer: ''
   
});

export default ResponsibleDealerReport;


// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/responsible-dealer-report.js